"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KonfektionierungHelper = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * The `KonfektionierungHelper` has the responsibility to
 * outsource konfektionierung helper functions
 */
class KonfektionierungHelper {
    constructor() {
        this.className = 'KonfektionierungHelper';
    }
    static getLeitungBeschriftungKonfektionierungTyp(leitungen) {
        const filteredLeitungList = leitungen.filterFreieLeitungenOut();
        if (filteredLeitungList
            .toArray()
            .filter((l) => l.beschriftung !== echain_shared_articles_1.LeitungBeschriftung.keine && l.beschriftung != null).length) {
            if (filteredLeitungList.count() > 3) {
                return echain_shared_articles_1.KonfektionierungTyp.BeschriftungLeitungFactorMoreThan_3;
            }
            else {
                return echain_shared_articles_1.KonfektionierungTyp.BeschriftungLeitungFactorLessThan_4;
            }
        }
        return undefined;
    }
    static hasLeitungAnyBeschriftung(leitungen) {
        const filteredLeitungList = leitungen.filterFreieLeitungenOut();
        return filteredLeitungList
            .toArray()
            .filter((l) => l.beschriftung !== echain_shared_articles_1.LeitungBeschriftung.keine && l.beschriftung != null).length;
    }
}
exports.KonfektionierungHelper = KonfektionierungHelper;
//# sourceMappingURL=KonfektionierungHelper.js.map